import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@mui/material";

/**
 * Modern Popup Dialog Component
 * Props:
 *  - open: boolean
 *  - title: string
 *  - onClose: function
 *  - onConfirm: function
 *  - confirmText: string
 *  - cancelText: string
 *  - showCancel: boolean
 */
export default function PopupDialog({
  open,
  title = "Important Disclaimer",
  onClose,
  onConfirm,
  confirmText = "I Understand",
  cancelText = "Cancel",
  showCancel = false,
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          padding: 1,
        },
      }}
    >
      {title && (
        <DialogTitle sx={{ fontWeight: 700, fontSize: "1.3rem" }}>
          {title}
        </DialogTitle>
      )}

      <DialogContent>
        <Typography
          variant="body1"
          sx={{
            lineHeight: 1.6,
            fontSize: "0.95rem",
            color: "text.secondary",
          }}
        >
          The data provided on this webpage of gharnmakaan.com is for informational
          purposes only. No representation or warranty—express or implied—is made
          regarding its accuracy. Investment or property decisions should not be
          made solely based on this information.

          Always verify project details directly from the respective RERA website
          or contact the builder/advertiser before making any decision.

          For questions or feedback, contact us at info@gharnmakaan.com.
        </Typography>
      </DialogContent>

      <DialogActions sx={{ padding: 2 }}>
        {showCancel && (
          <Button onClick={onClose} variant="outlined" sx={{ borderRadius: 2 }}>
            {cancelText}
          </Button>
        )}

        <Button
          onClick={onConfirm || onClose}
          variant="contained"
          sx={{ borderRadius: 2 }}
        >
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}